import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetDeactivatesMembersInput } from '../../../domain/dtos/get-deactivates-members-input'
import { GetDeactivatesMembersOutput } from '../../../domain/dtos/get-deactivates-members-output'
import { QueryKey } from '../../../domain/enums/query-key'
import { GetDeactivatesMembers } from '../../../usecases/members/get-deactivates-members'

export const useGetDeactivatesMembers = (input: GetDeactivatesMembersInput) => {
  const container = useContainer()

  return useQuery<GetDeactivatesMembersOutput>(
    [QueryKey.getDeactivatesMembers, input.pageSize, input.page, input.search, input.productId],
    ({ signal }) => new GetDeactivatesMembers(container.get(HttpClient)).execute(input, signal),
    {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  )
}
